import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_InvoiceFree = _resolveComponent("InvoiceFree")!
  const _component_InvoiceManagement = _resolveComponent("InvoiceManagement")!
  const _component_InoviceAuthentication = _resolveComponent("InoviceAuthentication")!
  const _component_TaxAuthority = _resolveComponent("TaxAuthority")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_tabs, { type: "border-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, { label: "财务审批" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse, {
            accordion: "",
            modelValue: _ctx.activeNames,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeNames) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                name: "1",
                title: "财务审批-搜索"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    model: _ctx.queryForm,
                    class: "demo-form-inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "编号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.queryForm.no,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryForm.no) = $event)),
                            placeholder: "请输入编号",
                            clearable: "",
                            class: "form-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "打包编号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.queryForm.approvedRecordId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryForm.approvedRecordId) = $event)),
                            placeholder: "请输入打包编号",
                            clearable: "",
                            class: "form-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "Hr审批人" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.queryForm.approvedBy,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.queryForm.approvedBy) = $event)),
                            filterable: "",
                            placeholder: "选择一项"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.userId,
                                  label: item.alias,
                                  value: item.userId
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "费用类型" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.queryForm.reimburseType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.queryForm.reimburseType) = $event)),
                            placeholder: "选择一项"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item, idx) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: idx,
                                  label: _ctx.filterType(item),
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "审核状态" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.queryForm.financeApproveStatusList,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.queryForm.financeApproveStatusList) = $event)),
                            placeholder: "选择一项",
                            multiple: "",
                            "collapse-tags": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "未审核",
                                value: "APPROVE_SEC"
                              }),
                              _createVNode(_component_el_option, {
                                label: "已审核",
                                value: "APPROVE_SUCCESS"
                              }),
                              _createVNode(_component_el_option, {
                                label: "部分已审核",
                                value: "APPROVE_PART"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.queryMethod(true))),
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.queryMethod(false)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            style: {"width":"980px"},
            class: "mt-10",
            border: "",
            data: _ctx.approvalHistoryData,
            "max-height": _ctx.tableHeight - 240 + 'px'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "id",
                label: "打包编号",
                formatter: (row) => 'DB' + row.id
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "reimburseType",
                label: "费用类型"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.filterType(row.reimburseType)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "approvedName",
                label: "Hr审批人"
              }),
              _createVNode(_component_el_table_column, {
                prop: "approvedTime",
                label: "审批时间",
                width: "175"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.transformationTime(row.approvedTime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "subRecordsNum",
                label: "子单个数",
                align: "right"
              }),
              _createVNode(_component_el_table_column, {
                prop: "approvedNum",
                label: "审批个数",
                align: "right"
              }),
              _createVNode(_component_el_table_column, {
                prop: "payApproveStatus",
                label: "财务审批状态"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.statusFilter(row.payApproveStatus)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "ops",
                label: "操作",
                width: "80"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_router_link, {
                    to: {name:'ApprovalDetail',params:{id:row.id}}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "max-height"])), [
            [_directive_loading, _ctx.historyTableLoading]
          ]),
          _createVNode(_component_el_pagination, {
            background: "",
            small: "",
            layout: "sizes,prev, pager, next,total",
            total: _ctx.historyPageSetting.totalNum,
            class: "mt-10",
            style: {"float":"none"},
            onCurrentChange: _ctx.hisPageChange,
            "page-sizes": [10, 40, 100, 300, 500],
            currentPage: _ctx.historyPageSetting.page,
            "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.historyPageSetting.page) = $event)),
            "page-size": _ctx.historyPageSetting.size,
            "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.historyPageSetting.size) = $event)),
            onSizeChange: _ctx.hisSizeChange
          }, null, 8, ["total", "onCurrentChange", "currentPage", "page-size", "onSizeChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, { label: "财务审批记录" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse, { accordion: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                name: "1",
                title: "财务审批记录-搜索"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    model: _ctx.queryHisForm,
                    class: "demo-form-inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "编号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.queryHisForm.no,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.queryHisForm.no) = $event)),
                            clearable: "",
                            placeholder: "请输入编号",
                            class: "form-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "打包编号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.queryHisForm.approvedRecordId,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.queryHisForm.approvedRecordId) = $event)),
                            clearable: "",
                            placeholder: "请输入打包编号",
                            class: "form-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "Hr审批人" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.queryHisForm.approvedBy,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.queryHisForm.approvedBy) = $event)),
                            filterable: "",
                            placeholder: "选择Hr审批人",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.userId,
                                  label: item.alias,
                                  value: item.userId
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "财务审批人" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.queryHisForm.approvedSecBy,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.queryHisForm.approvedSecBy) = $event)),
                            filterable: "",
                            placeholder: "选择财务审批人",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.userId,
                                  label: item.alias,
                                  value: item.userId
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.queryHisMethod(true))),
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.queryHisMethod(false)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            style: {"width":"900px"},
            class: "mt-10",
            data: _ctx.financeApprovalHistoryList,
            "max-height": _ctx.tableHeight - 240 + 'px',
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "no",
                label: "序号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "approvedRecordId",
                label: "打包编号",
                formatter: (row) => 'DB' + row.approvedRecordId
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "approvedName",
                label: "HR审批人"
              }),
              _createVNode(_component_el_table_column, {
                prop: "secApprovedName",
                label: "财务审批人"
              }),
              _createVNode(_component_el_table_column, {
                prop: "secApprovedTime",
                label: "审批时间",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.transformationTime(row.secApprovedTime)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "max-height"])), [
            [_directive_loading, _ctx.historyTabLoading]
          ]),
          _createVNode(_component_el_pagination, {
            background: "",
            small: "",
            layout: "sizes,prev, pager, next,total",
            total: _ctx.pageSetting.totalNum,
            class: "mt-10",
            style: {"float":"none"},
            "page-sizes": [10, 40, 100, 300, 500],
            "page-size": _ctx.pageSetting.size,
            "onUpdate:page-size": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pageSetting.size) = $event)),
            onCurrentChange: _ctx.financeHisPageChange,
            currentPage: _ctx.pageSetting.page,
            "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pageSetting.page) = $event)),
            onSizeChange: _ctx.financeHisSizeChange
          }, null, 8, ["total", "page-size", "onCurrentChange", "currentPage", "onSizeChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, { label: "无票管理" }, {
        default: _withCtx(() => [
          _createVNode(_component_InvoiceFree)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "发票管理",
        lazy: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_InvoiceManagement)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "发票认证",
        lazy: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_InoviceAuthentication)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "税局认证",
        lazy: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TaxAuthority)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}